import { SelectString } from '../../../core/components/SelectString'
import type { MijlpaalColor } from '../types/Mijlpalen'

type MijlpaalOption = { type: string; label: string }

type MijlpaalValue = [string] | [string, MijlpaalColor] | null

interface Props {
  options: MijlpaalOption[]
  value: MijlpaalValue
  onFilterChange: (
    filter: { mijlpaal: MijlpaalValue },
    submit?: boolean,
  ) => void
}

export const FilterSelectMijlpaal = ({
  options,
  value,
  onFilterChange,
}: Props) => {
  const [rawType = null, color = null] = value ?? []
  const type = rawType || null

  const typeLabels: Record<string, string> = options.reduce(
    (labels, option) => ({ ...labels, [option.type]: option.label }),
    {} as Record<string, string>,
  )

  const handleTypeChange = (newType: string | null) => {
    const mijlpaal: MijlpaalValue = newType
      ? color
        ? [newType, color]
        : [newType]
      : color
        ? ['', color]
        : null

    onFilterChange({ mijlpaal })
  }

  return (
    <SelectString
      fullWidth
      value={type}
      options={options.map(({ type }) => type)}
      getOptionLabel={(code) => typeLabels[code] ?? code}
      label="Mijlpaal"
      onChange={handleTypeChange}
    />
  )
}
